import CryptoJS from 'crypto-js';

const KEY_LENGTH = 32;

export function getEncryptionKey() {
  const raw = process.env.REACT_APP_ENCRYPTION_KEY || '';
  if (!raw.trim()) return '';
  return raw.slice(0, KEY_LENGTH).padEnd(KEY_LENGTH, '0');
}

export function encryptPayload(data) {
  const secret = getEncryptionKey();
  if (!secret) return null;
  return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secret
  ).toString();
}

export function decryptPayload(base64) {
  const secret = getEncryptionKey();
  if (!secret || !base64 || typeof base64 !== 'string') return null;
  try {
    const bytes = CryptoJS.AES.decrypt(base64, secret);
    const str = bytes.toString(CryptoJS.enc.Utf8);
    return str ? JSON.parse(str) : null;
  } catch {
    return null;
  }
}

function tryParseJson(value) {
  if (typeof value !== 'string') return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

export function resolveEncryptedResponse(input) {
  if (!input) return null;
  if (Array.isArray(input)) return input;
  if (typeof input === 'string') {
    const decrypted = decryptPayload(input);
    if (decrypted) return decrypted;
    return tryParseJson(input);
  }
  if (typeof input !== 'object') return null;

  const encryptedCandidates = [
    input.encrypted_payload,
    input.encrypted_data,
    input.payload,
    input.data_encrypted,
    input.data,
    input.result,
    input.response,
  ];
  for (const candidate of encryptedCandidates) {
    if (typeof candidate === 'string') {
      const decrypted = decryptPayload(candidate);
      if (decrypted) return decrypted;
      const parsed = tryParseJson(candidate);
      if (parsed) return parsed;
    }
  }
  if (input.data && typeof input.data === 'object') {
    const nestedData = resolveEncryptedResponse(input.data);
    if (nestedData) return nestedData;
  }
  if (input.result && typeof input.result === 'object') {
    const nestedResult = resolveEncryptedResponse(input.result);
    if (nestedResult) return nestedResult;
  }
  return null;
}

export function normalizeEncryptedApiResponse(raw, useEncrypt) {
  if (!useEncrypt || raw === null || raw === undefined) {
    return raw;
  }
  const decrypted = resolveEncryptedResponse(raw);
  if (decrypted && typeof decrypted === 'object') {
    return decrypted;
  }
  return raw;
}

export function plainObjectFromFormData(formData) {
  const plain = {};
  for (const [key, value] of formData.entries()) {
    if (key === 'product_image') {
      continue;
    }
    if (key.endsWith('[]')) {
      const base = key.slice(0, -2);
      if (!plain[base]) {
        plain[base] = [];
      }
      plain[base].push(value);
    } else if (Object.prototype.hasOwnProperty.call(plain, key)) {
      if (!Array.isArray(plain[key])) {
        plain[key] = [plain[key], value];
      } else {
        plain[key].push(value);
      }
    } else {
      plain[key] = value;
    }
  }
  return plain;
}
